<!--
 * @Author: 月魂
 * @Date: 2021-01-29 09:26:30
 * @LastEditTime: 2022-01-20 14:05:52
 * @LastEditors: 月魂
 * @Description: 
 * @FilePath: \bingmayong-ukraine-mobile\src\views\Preface.vue
-->
<template>
  <div class="cont">
    <Header title="preface" />
    <van-row class="picWall">
      <van-col
        span="24"
        class="picItem"
        @click="handleJump(setting.head1.link)"
      >
        <img :src="setting.picItem1.pic1" width="100%" />
      </van-col>
      <van-col span="8" class="picItem" @click="handleJump(setting.head2.link)">
        <img :src="setting.picItem2.pic2" width="100%" />
        <div class="read">
          <span>{{ setting.picItem2.title }}</span>
          <br />
          <span>{{ setting.picItem2.des }}</span>
        </div>
      </van-col>
      <van-col span="8" class="picItem" @click="handleJump(setting.head3.link)">
        <img :src="setting.picItem3.pic3" width="100%" />
        <div class="read">
          <span>{{ setting.picItem3.title }}</span>
          <br />
          <span>{{ setting.picItem3.des }}</span>
        </div>
      </van-col>
      <van-col span="8" class="picItem" @click="handleJump(setting.head4.link)">
        <img :src="setting.picItem4.pic4" width="100%" />
        <div class="read">
          <span>{{ setting.picItem4.title }}</span>
          <br />
          <span>{{ setting.picItem4.des }}</span>
        </div>
      </van-col>
      <van-col span="8" class="picItem" @click="handleJump(setting.head5.link)">
        <img :src="setting.picItem5.pic5" width="100%" />
        <div class="read">
          <span>{{ setting.picItem5.title }}</span>
          <br />
          <span>{{ setting.picItem5.des }}</span>
        </div>
      </van-col>
      <van-col span="8" class="picItem" @click="handleJump(setting.head6.link)">
        <img :src="setting.picItem6.pic6" width="100%" />
        <div class="read">
          <span>{{ setting.picItem6.title }}</span>
          <br />
          <span>{{ setting.picItem6.des }}</span>
        </div>
      </van-col>
      <van-col span="8" class="picItem" @click="handleJump(setting.head7.link)">
        <img :src="setting.picItem7.pic7" width="100%" />
        <div class="read">
          <span>{{ setting.picItem7.title }}</span>
          <br />
          <span>{{ setting.picItem7.des }}</span>
        </div>
      </van-col>
    </van-row>
    <img
      src="http://cdn.topartsintermational.com/hisLine.png"
      width="100%"
      style="margin-top: 16px"
    />
    <div class="text">
      <div class="title">{{ setting.article.title }}</div>
      <p class="text-cont">{{ setting.article.des1 }}</p>
      <p class="text-cont">{{ setting.article.des2 }}</p>
    </div>
    <h3 style="text-align: center; padding-bottom: 8px; color: #cfcfcf">
      Visitors: {{ this.sum }}
    </h3>
    <Footer />
  </div>
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
import axios from 'axios';

export default {
  name: 'Preface',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      sum: null,
      setting: {
        head1: {
          avatar: 'http://cdn.topartsintermational.com/ebbs.png',
          title: this.$t('message.link.history'),
          link: '/history',
        },
        head2: {
          avatar: 'http://cdn.topartsintermational.com/past.png',
          title: this.$t('message.link.warriors'),
          link: '/warriors',
        },
        head3: {
          avatar: 'http://cdn.topartsintermational.com/ancient.png',
          title: this.$t('message.link.ancient'),
          link: '/ancient',
        },
        head4: {
          avatar: 'http://cdn.topartsintermational.com/originality.png',
          title: this.$t('message.link.culture'),
          link: '/culture',
        },
        head5: {
          avatar: 'http://cdn.topartsintermational.com/visiting.png',
          title: this.$t('message.link.visit'),
          link: '/visit',
        },
        head6: {
          avatar: 'http://cdn.topartsintermational.com/creation.png',
          title: this.$t('message.link.creation'),
          link: '/creation',
        },
        head7: {
          avatar: 'http://cdn.topartsintermational.com/unusual.png',
          title: this.$t('message.link.game'),
          link: '/game',
        },

        picItem1: {
          pic1: 'http://image.wearetogether.com.cn/hisbg-ukraine.jpg',
          title: '历史绵迭',
          des: this.$t('message.link.history')
        },
        picItem2: {
          pic2: 'http://cdn.topartsintermational.com/pic2.png',
          title: '览古观今',
          des: this.$t('message.link.warriors')
        },
        picItem3: {
          pic3: 'http://cdn.topartsintermational.com/pic3.png',
          title: '古法艺作',
          des: this.$t('message.link.ancient')
        },
        picItem4: {
          pic4: 'http://cdn.topartsintermational.com/pic4.png',
          title: '中西匠心',
          des: this.$t('message.link.culture')
        },
        picItem5: {
          pic5: 'http://cdn.topartsintermational.com/pic5.png',
          title: '途秦欲旅',
          des: this.$t('message.link.visit')
        },
        picItem6: {
          pic6: 'http://cdn.topartsintermational.com/pic6.png',
          title: '访古出新',
          des: this.$t('message.link.creation')
        },
        picItem7: {
          pic7: 'http://cdn.topartsintermational.com/pic7.png',
          title: '奇思律动',
          des: this.$t('message.link.game')
        },
        imgs: {
          bg: 'http://cdn.topartsintermational.com/prefaceBg-se.jpg',
          line: 'http://cdn.topartsintermational.com/line.png',
        },
        article: {
          title: this.$t('message.link.preface'),
          des1: this.$t('message.preface.des1'),
          des2: this.$t('message.preface.des2'),
        }
      },
    }
  },
  mounted() {
    axios.get('/visitors/UKR-QIN').then(res => {
      this.sum = res.data;
    })
    axios.post('/visitors/UKR-QIN')
  },
  methods: {
    handleJump (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    }
  },
}
</script>

<style scoped lang="less">
.cont {
  min-height: 100vh;
  background: url("http://image.wearetogether.com.cn/prefaceBg-ukraine.jpg")
    no-repeat;
  background-size: contain;
  box-sizing: border-box;
  background-color: #a60009;
  padding-top: 136px;
  .picWall {
    padding: 0 10px;
    .picItem {
      position: relative;
      margin-bottom: 4px;
      .read {
        position: absolute;
        left: 0;
        bottom: 0;
        font-size: 12px;
        color: #fff;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        padding: 2px 0 6px;
        box-sizing: border-box;
        text-align: center;
      }
    }
  }
  .text {
    box-sizing: border-box;
    color: #fff;
    line-height: 1.8;
    letter-spacing: 0.4px;
    padding: 0 10px;
    margin-bottom: 16px;
    .title {
      text-align: center;
    }
    .text-cont {
      text-indent: 2em;
    }
  }
}
</style>